
const getDefaultState = () => ({
  list: {
    items: [],
    loading: false,
    errorMessage: '',
    error: false,
    noContent: false,
  },
  channels: {
    items: [],
  },
  jobs: {
    items: [],
  },
  channelProducts: {
    items: [],
  },
  pushPrices: {
    items: [],
  },
  filter: {
    channel: {},
    type: {},
    channelProduct: {},
    paginationIndex: 1,
    loadNewPage: 0,
    loading: false,
    error: false,
    noContent: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/prices/defaultState.js